import { Helmet } from "react-helmet-async";

const SITE_URL = "https://whatthescan.app";

export const Seo = ({ title, description, path = "/" }) => {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:url" content={url} />
    </Helmet>
  );
};
